// ======================================================================
// File: src/modules/ppe/pages/procurement/purchaseInvoice/view/components/PurchaseInvoiceTotalsPanel.jsx
// Module: PPE → Procurement → Purchase Invoice
//
// Purpose:
// - Finance Summary Panel
// - Sticky right-side totals card
// - Displays invoice financial summary
// - Displays matching summary
//
// Notes:
// - Read only component
// - Calculations are performed in parent component
// - Matching values may be unavailable in Phase 1
// ======================================================================

import React from "react";

const PurchaseInvoiceTotalsPanel = ({
  header = {},
  totals = {}
}) => {
  const matchingStatus =
    header?.matching_status || "NOT_MATCHED";

  const materialTotal =
    Number(totals.materialTotal || 0);

  const materialGST =
  Number(totals.materialGST || 0);

const chargeValue =
  Number(totals.chargeValue || 0);

const chargeGST =
  Number(totals.chargeGST || 0);

const grandTotal =
  Number(totals.grandTotal || 0);


  const formatAmount = (value) =>
    value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

  const getMatchingClass = () => {
    switch (matchingStatus) {
      case "MATCHED":
        return "matching-success";

      case "PARTIALLY_MATCHED":
        return "matching-warning";

      case "EXCEPTION":
        return "matching-error";

      default:
        return "matching-pending";
    }
  };

  return (
    <div className="pi-right-panel">

      {/* ================================================= */}
      {/* TOTALS CARD                                       */}
      {/* ================================================= */}

      <div className="pi-card pi-sticky-card">

        <div className="pi-card-title">
          Totals
        </div>

        <div className="pi-total-row">
          <span>Material Total</span>
          <strong>
            {formatAmount(materialTotal)}
          </strong>
        </div>

        <div className="pi-total-row">
  <span>Material GST</span>
  <strong>
    {formatAmount(materialGST)}
  </strong>
</div>

<div className="pi-total-row">
  <span>Charge Value</span>
  <strong>
    {formatAmount(chargeValue)}
  </strong>
</div>

<div className="pi-total-row">
  <span>Charge GST</span>
  <strong>
    {formatAmount(chargeGST)}
  </strong>
</div>

        <hr />

        <div className="pi-grand-total-row">
          <span>Grand Total</span>
          <strong>
            {formatAmount(grandTotal)}
          </strong>
        </div>

      </div>

      {/* ================================================= */}
      {/* MATCHING SUMMARY                                  */}
      {/* ================================================= */}

      <div className="pi-card">

        <div className="pi-card-title">
          Matching Summary
        </div>

        <div
          className={`matching-status-card ${getMatchingClass()}`}
        >
          {matchingStatus}
        </div>

        <div className="pi-summary-row">
          <span>Matched Lines</span>
          <strong>
            {header?.matched_lines ?? "--"}
          </strong>
        </div>

        <div className="pi-summary-row">
          <span>Unmatched Lines</span>
          <strong>
            {header?.unmatched_lines ?? "--"}
          </strong>
        </div>

        <div className="pi-summary-row">
          <span>Variance Amount</span>
          <strong>
            {header?.variance_amount ?? "--"}
          </strong>
        </div>

      </div>

    </div>
  );
};

export default PurchaseInvoiceTotalsPanel;